import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    eventName: String,
    detail: { type: Object, default: {} },
    autoDispatch: { type: Boolean, default: false },
    targetId: String
  }

  connect () {
    this.element.dispatchEvent(new CustomEvent('connect'))
    if (this.autoDispatchValue) this.dispatch()
  }

  dispatch () {
    const event = new CustomEvent(this.eventNameValue, {
      detail: this.detailValue,
      bubbles: this.hasTargetIdValue
    })

    if (this.hasTargetIdValue) {
      document.getElementById(this.targetIdValue)?.dispatchEvent(event)
    } else {
      window.dispatchEvent(event)
    }
  }
}
